module.exports = __webpack_public_path__ + "static/media/no-photo-placeholder.ff454622.svg";